module.exports = __webpack_public_path__ + "static/media/triton.75ea1d27.png";